import { useEffect, useState } from "react";
import useAxiosPost from "../../hooks/useAxiosPost";
import { Col, Row } from "antd";
import ConnectedPPPoEUsersTable from "../Tables/ConnectedPPPoEUsersTable";
import DisconnectRadiusConnectedUserModal from "../Modals/DisconnectRadiusConnectedUserModal";
const ViewRadiusConnectedPPPoeUsers = () => {
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<ResponseProp>("endUsers/getConnectedUsers");
  const [
    postSearchAPi,
    searchApiResponse,
    searchApiError,
    searchApiLoading,
    searchApiMessage,
    searchApiErrorCount,
  ] = useAxiosPost<UserSearchApiProp>("endUsers/searchRadiusConnectedUsers");
  const [searchedUsers, setSearchedUsers] = useState<ConnectedUser[]>([]);
  const [connectedUsers, setConnectedUsers] = useState<ConnectedUser[]>([]);
  const [activeUser, setActiveUser] = useState<ConnectedUser | null>(null);
  const [showDisconnect, setShowDisconnect] = useState<boolean>(false);
  const [isSearch, setIsSearch] = useState<boolean>(false);

  const [pagination, setPagination] = useState<PaginationProp>({
    totalPages: 0,
    currentPage: 1,
    previousPage: null,
    nextPage: null,
    totalCount: 0,
    pageSize: 50,
  });
  const [searchPagination, setSearchPagination] = useState<PaginationProp>({
    totalPages: 0,
    currentPage: 1,
    previousPage: null,
    nextPage: null,
    totalCount: 0,
    pageSize: 100,
  });
  useEffect(() => {
    postApiData({ page: 1 });
  }, []);
  useEffect(() => {
    if (apiResponse !== null) {
      const data: any = apiResponse.responseData;
      const {
        currentPage,
        nextPage,
        pageSize,
        previousPage,
        totalCount,
        totalPages,
        connectedUsers,
      } = data;
      setPagination({
        currentPage,
        totalPages,
        nextPage,
        previousPage,
        totalCount,
        pageSize,
      });
      setConnectedUsers(connectedUsers || []);
    }
  }, [apiResponse]);
  const handleAllUsersPageSwitch = (pageNumber: number) => {
    postApiData({ page: pageNumber });
  };
  const handleDisconnectUser = (user: ConnectedUser) => {
    setActiveUser(user);
    setShowDisconnect(true);
  };
  const handleClose = (isReload: boolean) => {
    if (activeUser && isReload === true) {
      const _updatedUsers = connectedUsers.filter(
        (item) => item._id !== activeUser._id
      );
      setConnectedUsers(_updatedUsers);
    }
    setShowDisconnect(false);
  };
  const handleSearch = (search: string) => {
    if (search.trim() === "") {
      setIsSearch(false);
      return;
    }
    if (search.length < 3) {
      return;
    }
    setIsSearch(true);
    postSearchAPi({ search });
  };

  useEffect(() => {
    if (searchApiResponse !== null) {
      const data: any = searchApiResponse.responseData;

      setSearchedUsers(data || []);
    }
  }, [searchApiResponse]);
  return (
    <>
      {showDisconnect === true && activeUser !== null && (
        <DisconnectRadiusConnectedUserModal
          intPkEndUserID={activeUser.authObj.intPkEndUserID}
          intPkNasDeviceID={activeUser.acctObj.intPkNasDeviceID}
          show={showDisconnect}
          handleClose={handleClose}
        />
      )}
      <Row className="full-width-row ">
        <Col span={24}>
          <ConnectedPPPoEUsersTable
            isLoading={apiLoading || searchApiLoading}
            users={isSearch === true ? searchedUsers : connectedUsers}
            pagination={isSearch === true ? searchPagination : pagination}
            handlePageSwitch={handleAllUsersPageSwitch}
            handleDisconnectUser={handleDisconnectUser}
            handleSearch={handleSearch}
          />
        </Col>
      </Row>
    </>
  );
};
export default ViewRadiusConnectedPPPoeUsers;
